import CheckboxSmallIcon from '../../../assets/icons/icon-checkbox-small.svg?react'
import CheckboxSmallCheckedIcon from '../../../assets/icons/icon-checkbox-small-checked.svg?react'
import CheckboxBigIcon from '../../../assets/icons/icon-checkbox-big.svg?react'
import CheckboxBigCheckedIcon from '../../../assets/icons/icon-checkbox-big-checked.svg?react'
import css from './Checkbox.module.css'

interface CheckboxProps {
    checked?: boolean
    size?: 'small' | 'big'
    onChange?: (checked: boolean) => void
}

const Checkbox = ({ checked = false, size = 'small', onChange }: CheckboxProps) => {
    const handleClick = () => {
        onChange?.(!checked)
    }

    const className = [
        css.checkbox,
        size === 'big' && css.big
    ].filter(Boolean).join(' ')

    const renderIcon = () => {
        if (size === 'big') {
            return checked ? <CheckboxBigCheckedIcon /> : <CheckboxBigIcon />
        }
        return checked ? <CheckboxSmallCheckedIcon /> : <CheckboxSmallIcon />
    }

    return (
        <div className={className} onClick={handleClick}>
            {renderIcon()}
        </div>
    )
}

export default Checkbox
